import { useSessionTimeout } from '../hooks/useSessionTimeout';
import SessionTimeoutModal from './SessionTimeoutModal';

/**
 * Provider component that displays session timeout warning modal
 * Wraps the useSessionTimeout hook and displays the modal
 */
const SessionTimeoutProvider = ({ children }) => {
  const { showWarning, timeRemaining, extendSession, logout } = useSessionTimeout();

  return (
    <>
      {children}
      <SessionTimeoutModal
        show={showWarning}
        timeRemaining={timeRemaining}
        onExtend={extendSession}
        onLogout={logout}
      />
    </>
  );
};

export default SessionTimeoutProvider;
